import moment from 'moment';

export const formatTimestamp = (timestamp) => {
  if (!timestamp) {
    return '-';
  }
  return moment(timestamp).format('MM-DD-YYYY:hh:mm A');
};
